import { render } from "./IconWithBadge.vue?vue&type=template&id=70579943"
import script from "./IconWithBadge.vue?vue&type=script&lang=js"
export * from "./IconWithBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__